import React from 'react'
import {generatePath} from 'react-router'
import {Link as RouterLink} from 'react-router-dom'
import {Routes} from '../../../common/Routes'
import {BoxWithoutRentals} from '../../../common/types/box'
import {Rental} from '../../../common/types/rental'
import {resolveBoxDisplayName} from '../../../common/utils/resolveBoxDisplayName'
import {Link} from '../../../webui/Link'
import {SortablePaginatedTable} from '../../../webui/table/sortable-paginated-table/SortablePaginatedTable'
import {TableHeadCell} from '../../../webui/table/sortable-paginated-table/TableHeadCell'
import {Typography} from '../../../webui/Typography'
import {generateNumberOfRentalsPerBoxMap} from '../rentals/utils/generateNumberOfRentalsPerBoxMap'

interface Props {
  boxes: BoxWithoutRentals[]
  rentals: Rental[]
}

interface PublicUsersPerBoxTableData {
  id: string
  box?: BoxWithoutRentals
  share: number
}

const createTableHeadCells = (): TableHeadCell<PublicUsersPerBoxTableData>[] => [
  {
    id: 'box',
    label: 'Box',
    render: (row) =>
      row.box ? (
        <Link
          component={RouterLink}
          to={generatePath(Routes.BOX, {
            id: row['box'].id,
          })}
        >
          {resolveBoxDisplayName(row['box'])}
        </Link>
      ) : (
        ''
      ),
  },
  {
    id: 'share',
    label: 'Share',
    render: (row) => `${row.share}%`,
  },
]

export const PublicUsersPerBoxTable: React.FC<Props> = ({boxes, rentals}) => {
  const numberOfRentalsPerBoxEntries = Object.entries(generateNumberOfRentalsPerBoxMap(rentals))
    .map(([boxId, numberOfUsers]) => {
      const box = boxes.find((b) => b.id === boxId)
      return {
        id: boxId,
        box,
        share: Math.round((numberOfUsers / rentals.length) * 100),
      }
    })
    .filter((value) => value.share !== 0)

  if (numberOfRentalsPerBoxEntries.length <= 0) {
    return <Typography>{'There were no users during this period'}</Typography>
  }

  return (
    <SortablePaginatedTable
      title={'Andel pifflare per box'}
      initialRowsPerPage={numberOfRentalsPerBoxEntries.length}
      initialOrderByKey={'share'}
      initialOrder={'desc'}
      rows={numberOfRentalsPerBoxEntries}
      searchEnabled={false}
      tableHeadCells={createTableHeadCells()}
    />
  )
}
